export enum CurrenciesEnum {
    AUD = "AUD",
    USD = "USD",
    NZD = "NZD",
    CAD = 'CAD'
}

export const MINIMAL_DONATION_AMOUNT = 2;